import { render, staticRenderFns } from "./ChatSuggestions.vue?vue&type=template&id=b48acac8&scoped=true"
import script from "./ChatSuggestions.vue?vue&type=script&lang=js"
export * from "./ChatSuggestions.vue?vue&type=script&lang=js"
import style0 from "./ChatSuggestions.vue?vue&type=style&index=0&id=b48acac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48acac8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
